import { countries$, fetchCountries } from "@a365/api";

/**
 * Función para cargar países
 */
export const loadCountries = () => {
  return fetchCountries();
};

// Función de compatibilidad con el código existente
export const getCountries = loadCountries;

// Re-exportar el observable para compatibilidad
export { countries$ };
